export const TITLE_SEPARATOR = '|'
export const TITLE_SUFFIX = 'learnerPortal'
